<template>
  <v-btn small icon @click="copyLinesToClipboard" v-if="isSupplierCapableOf({ connectorName: item.supplier.connector, capability: 'orderHistory' }) && linesToOrder.length > 0">
    <v-icon small>mdi-cart-plus</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['item'],
  computed: {
    ...mapGetters(['isSupplierCapableOf']),
    linesToOrder () {
      return this.item.selected.map(item => (item.linePrice.quantityToOrder + ',' + item.articles.sku))
    }
  },
  methods: {
    copyLinesToClipboard () {
      navigator.clipboard.writeText(this.linesToOrder.join('\n'))
        .then(() => {
          window.open('https://www.digikey.com/ordering/shoppingcart', '_blank')
        })
        .catch(() => {
          alert('Your browser do not allow copy/past from the app.')
        })
    }
  }
}
</script>
